export class Result<T> {

    constructor(public result: T, public success: boolean = true, public message?: string) {
    }
}
